module.exports = __webpack_public_path__ + "img/celebrate.fcfb619a.jpg";